import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'firstInitial'
})
export class FirstInitialPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';
    return value.trim().charAt(0).toUpperCase();
  }
}
